import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Button, Typography } from "@mui/material";
import { ElementType } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

export interface NoAccessProps {
  /** Heading level of the title. Defaults to 1, since it replaces the whole page. */
  headingLevel?: 1 | 2 | 3;
}

/**
 * The no-access state (FR-047, FR-048): shown when the signed-in person's role lacks the page's
 * permission, or when the server answers 403. It explains why and links back to the console home.
 */
export const NoAccess = ({ headingLevel = 1 }: NoAccessProps) => {
  const { t } = useTranslation();
  return (
    <Box
      data-testid="no-access"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 1,
        px: 3,
        py: 6,
      }}
    >
      <Box
        aria-hidden="true"
        sx={{ color: "text.secondary", display: "flex", mb: 1 }}
      >
        <LockOutlinedIcon fontSize="large" />
      </Box>
      <Typography
        component={`h${headingLevel}` as ElementType}
        sx={{ m: 0, fontSize: 18, fontWeight: 800, color: "text.primary" }}
      >
        {t("noAccess.title")}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", maxWidth: 420 }}
      >
        {t("noAccess.body")}
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Button variant="contained" component={RouterLink} to="/grading">
          {t("noAccess.back")}
        </Button>
      </Box>
    </Box>
  );
};

export default NoAccess;
